// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { foodRecipeId } from './FoodRecipe';
import { invItemId } from './InvItem';
import { brewBatchId } from './BrewBatch';
import { invProductId } from './InvProduct';
import { z } from 'zod';
export const foodRecipeIngredientId = (z.number());
export const foodRecipeIngredient = z.object({
    id: foodRecipeIngredientId,
    recipe_id: foodRecipeId,
    item_id: invItemId.nullable(),
    brew_batch_id: brewBatchId.nullable(),
    name: z.string(),
    percentage: z.number().nullable(),
    prepared: z.boolean(),
    note: z.string().nullable(),
    display_order: z.number(),
    created_at: z.date(),
    product_id: invProductId.nullable(),
    stand_in_brew_batch_id: brewBatchId.nullable(),
});
export const foodRecipeIngredientInitializer = z.object({
    id: foodRecipeIngredientId.optional(),
    recipe_id: foodRecipeId,
    item_id: invItemId.optional().nullable(),
    brew_batch_id: brewBatchId.optional().nullable(),
    name: z.string(),
    percentage: z.number().optional().nullable(),
    prepared: z.boolean().optional(),
    note: z.string().optional().nullable(),
    display_order: z.number().optional(),
    created_at: z.date().optional(),
    product_id: invProductId.optional().nullable(),
    stand_in_brew_batch_id: brewBatchId.optional().nullable(),
});
export const foodRecipeIngredientMutator = z.object({
    id: foodRecipeIngredientId.optional(),
    recipe_id: foodRecipeId.optional(),
    item_id: invItemId.optional().nullable(),
    brew_batch_id: brewBatchId.optional().nullable(),
    name: z.string().optional(),
    percentage: z.number().optional().nullable(),
    prepared: z.boolean().optional(),
    note: z.string().optional().nullable(),
    display_order: z.number().optional(),
    created_at: z.date().optional(),
    product_id: invProductId.optional().nullable(),
    stand_in_brew_batch_id: brewBatchId.optional().nullable(),
});
//# sourceMappingURL=FoodRecipeIngredient.js.map